<div class="snakebar" *ngIf="show">
  <div class="snakebar-inner">
    <div class="snakebarText">
      <!-- &#xe914; -->
      <!-- <i class="risk-icons" [innerHTML]="icon"></i> -->
      <span class="icon"><img src="./assets/images/alert-triangle-outline.svg" alt="" /></span>
      {{ message }}
    </div>
    <button (click)="close()">[ Close ]</button>
  </div>
</div>
